import { createContext } from 'react';

const BearerTokenGetterContext = createContext(async () => {
    console.error('No BearerTokenGetter provided');
    return null;
});

export { BearerTokenGetterContext };
